import { useState } from 'react';
import { File, Trash2 } from 'lucide-react';
import type { ProjectFile } from '../../types/project';
import styles from './FileTree.module.css';

interface FileTreeProps {
  files: ProjectFile[];
  onOpenFile: (fileId: string) => void;
  onDeleteFile: (fileId: string) => Promise<void>;
}

const LANG_COLORS: Record<string, string> = {
  typescript: '#3178c6',
  typescriptreact: '#3178c6',
  javascript: '#f7df1e',
  javascriptreact: '#f7df1e',
  rust: '#dea584',
  json: '#5d9b46',
  toml: '#9c4221',
  css: '#264de4',
  html: '#e34c26',
  markdown: '#083fa1',
  mist: '#9b59b6',
};

export function FileTree({ files, onOpenFile, onDeleteFile }: FileTreeProps) {
  const [hoveredId, setHoveredId] = useState<string | null>(null);

  const sorted = [...files].sort((a, b) => a.path.localeCompare(b.path));

  return (
    <div className={styles.tree}>
      {sorted.map(file => (
        <div
          key={file.id}
          className={styles.fileRow}
          onMouseEnter={() => setHoveredId(file.id)}
          onMouseLeave={() => setHoveredId(null)}
        >
          <button
            className={styles.fileItem}
            onClick={() => onOpenFile(file.id)}
            title={file.path}
          >
            <File
              size={14}
              style={{ color: LANG_COLORS[file.language] ?? 'var(--color-text-tertiary)' }}
            />
            <span className={styles.fileName}>{file.name}</span>
            {file.isModified && <span className={styles.modifiedDot} />}
          </button>
          {hoveredId === file.id && (
            <button
              className={styles.deleteBtn}
              onClick={(e) => { e.stopPropagation(); onDeleteFile(file.id); }}
              title="Delete file"
            >
              <Trash2 size={12} />
            </button>
          )}
        </div>
      ))}
    </div>
  );
}
